module.exports = __webpack_public_path__ + "media/images/icon__arrow-right-392a83c2725e717585353def89dba528.png";